module.exports = __webpack_public_path__ + "img/ai_bubble_button.4e2fddd.png";